import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import * as pdfMake from "pdfmake/build/pdfmake";
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';

import { ComponentBase, DbaDataTableColumn, exportAsCsvFile, NumberInputDialogComponent, NumberInputDialogData, SelectDialogComponent, SelectDialogData } from '@definitiv-packages/angular-dba-library';

import { ProjectLanguage, ScanPrefix, UuidModel, UuidModelService } from '../../../../../roofsafetymanagement-library/src/public-api';

class StringObject {
  constructor(
    public value: string
  ) { }
}

@Component({
  selector: 'app-uuid-view',
  templateUrl: './uuid-view.component.html',
  styleUrls: ['./uuid-view.component.scss'],
  standalone: false
})
export class UuidViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public uuidList: UuidModel[] = [];

  public columnList: DbaDataTableColumn<UuidModel, ProjectLanguage>[] = [
    { id: 'Uuid', label: 'ElectronicID' }
  ];

  constructor(
    private uuidService: UuidModelService,
    private matDialog: MatDialog
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.uuidList = await this.uuidService.getFilteredList();
    } finally {
      this.loading = false;
    }
  }

  public async CreateCodes(): Promise<void> {
    var data = new NumberInputDialogData();
    data.title = this.languageService.getText(this.language.AnzahlElectronicIDs);
    data.placeholder = this.languageService.getText(this.language.AnzahlElectronicIDs);
    var amount = await firstValueFrom(this.matDialog.open(NumberInputDialogComponent, { data: data }).afterClosed());
    if (!amount) return;

    var uuidList = [];
    for (var i = 0; i < amount; i++) {
      var uuid = new UuidModel();
      uuid.Uuid = crypto.randomUUID();
      uuidList.push(uuid);
    }

    try {
      this.loading = true;
      await this.uuidService.createList(uuidList);
      await this.ngOnInit();
    } finally {
      this.loading = false;
    }
  }

  public async export(): Promise<void> {
    var data = new SelectDialogData([new StringObject('PDF'), new StringObject('Excel')], ['value']);
    var result: StringObject | undefined = await firstValueFrom(this.matDialog.open(SelectDialogComponent, { data: data }).afterClosed());
    if (!result) return;
    if (result.value == 'PDF') this.exportPdf(this.uuidList.map(x => '#' + ScanPrefix.SafetyPointId + '#' + x.Uuid));
    else if (result.value == 'Excel') exportAsCsvFile(this.uuidList.map(x => { return { Uuid: '#' + ScanPrefix.SafetyPointId + '#' + x.Uuid }; }), 'export.csv');
  }

  public exportPdf(list: string[]): void {
    var body: any[] = [];
    list.forEach(element => {
      var o: any = [
        { qr: element, fit: 60, border: [false, false, false, false], alignment: 'left', margin: [0, 0, 0, 20] },
        { text: element, border: [false, false, false, false], alignment: 'left', margin: [60, 0, 0, 20] }
      ]
      body.push(o);
    });

    const docDefinition: TDocumentDefinitions = {
      pageMargins: [70, 100, 50, 90],
      header: (currentPage, pageCount, pageSize) => ({
        columns: [
          {

          },
        ],
        margin: [70, 30, 50, 0],
      } as Content),
      footer: (currentPage, pageCount) => {
        return {

          table: {
            widths: ['*'],
            body: [
              [
                { text: 'Seite' + " " + currentPage.toString() + " von " + pageCount, alignment: 'right', style: 'adressheaderbold' }
              ],
              [
                { canvas: [{ type: 'line', x1: 5, y1: 0, x2: 720, y2: 0, lineWidth: 1, lineColor: '#000000' }] }
              ]
            ]
          },
          margin: [70, 0, 50, 70],
          layout: 'noBorders'
        };
      },

      content: [
        {
          table: {
            widths: ['auto', '*'],
            body: [
              ...body
            ]
          },
          layout: 'noBorders'
        }
      ] as Content,
      styles: {
        header: {
          fontSize: 16,
          bold: false,
          color: '#42B98A',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        subheader: {
          fontSize: 16,
          bold: false,
          color: '#166C43',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        headertext: {
          fontSize: 12,
          bold: false,
          color: '#808080',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        adressheader: {
          fontSize: 8,
          bold: false,
          color: '#808080',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        adressheaderbold: {
          fontSize: 8,
          bold: true,
          color: '#000000',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        adress: {
          fontSize: 12,
          bold: false,
          color: '#000000',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        adressbold: {
          fontSize: 12,
          bold: true,
          color: '#000000',
          alignment: 'left',
          margin: [0, 0, 0, 0]
        },
        footer: {
          fontSize: 10,
          italics: true,
          alignment: 'center',
          margin: [0, 20, 0, 0]
        }
      },
      defaultStyle: {
        fontSize: 10
      }
    }

    pdfMake.createPdf(docDefinition).download('export.pdf');
  }
}
